import React from 'react';


import {useQuery} from 'views/module';
import Interview from 'views/scenes/caregiver_interview/CaregiverInterview';

const CaregiverInterview = (props) => {
  const query = useQuery();
  return (
    <Interview
      jobRn={query.job}
    />
  );
};

CaregiverInterview.propTypes = {
};

export default React.memo(CaregiverInterview);

